// extracted by mini-css-extract-plugin
module.exports = {"popover-panel":"index__popover-panel___2dn7D","popoverPanel":"index__popover-panel___2dn7D","close":"index__close___1qmLf"};